/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

export enum PayoutCommonCascadeV1QueueItemType {
    QUEUE_ITEM_TYPE_UNSPECIFIED = 'QUEUE_ITEM_TYPE_UNSPECIFIED',
    QUEUE_ITEM_TYPE_GROUP = 'QUEUE_ITEM_TYPE_GROUP',
    QUEUE_ITEM_TYPE_TEMPLATE = 'QUEUE_ITEM_TYPE_TEMPLATE',
}
